'use client';

import { useEffect } from 'react';

import { Headline, HeadlineLevel, Section, TrilogyColor } from '@bytel/trilogy-react-ts';

import { logger } from '@services/loggers';

// import with @components => break server action basePath

type ErrorPageProps = { error: Error & { digest?: string }; reset: () => void };

function ErrorPage({ error }: ErrorPageProps) {
    useEffect(() => {
        logger.error(error);
    }, [error]);

    return (
        <div className='error-page'>
            <Section background={TrilogyColor.GREY_LIGHTER}>
                <Headline level={HeadlineLevel.LEVEL1}>Oops, il y a une erreur !</Headline>
            </Section>
        </div>
    );
}

export default ErrorPage;
